module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"button":{"apply_filter":"読み込み","clear_filter":"クリア"}},"en":{"button":{"apply_filter":"Apply","clear_filter":"Clear"}}}')
  delete Component.options._Ctor
}
